import { EChatMessageSource } from '@adaptiva/core/chat';
import { InjectionToken } from '@angular/core';

export const CHAT_MENU_CONTEXT: InjectionToken<EChatMessageSource> = new InjectionToken('CHAT_MENU_CONTEXT');
